import { Component, Input } from '@angular/core';
import { ReviewContainerBase } from '@lsqlabs/dr-application-shared';

@Component({
    selector: 'dr-review-admin',
    styleUrls: ['./dr-review-admin.component.scss'],
    templateUrl: './dr-review-admin.component.html'
})
export class ReviewAdminContainer extends ReviewContainerBase {
    @Input() adminView = true;

    public ngOnInit(): void {
        this.stageSchemas = this.getReviewableStageSchemas();
    }
}
